import config from 'config';
import { http_client } from './api';

const getList = async (page = null, perPage = null, sort = null, orderBy = null, search = null, month = null, year = null, paymentStatus = null, excludeMonth = null, excludeYear = null, newStudentThisMonth = null) => {
  return http_client
    .get(
      config.apiUrl +
        'verifikasi-pembayaran?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${month ? '&month=' + month : ''}` +
        `${year ? '&year=' + year : ''}` +
        `${excludeMonth ? '&exclude_month=' + excludeMonth : ''}` +
        `${excludeYear ? '&exclude_year=' + excludeYear : ''}` +
        `${newStudentThisMonth ? '&new_student_this_month=1' : ''}` +
        `${paymentStatus ? '&payment_status=' + paymentStatus : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'verifikasi-pembayaran/' + id).then((response) => {
    return response.data;
  });
};

const verifikasi = async (id) => {
  return http_client.post(config.apiUrl + 'verifikasi-pembayaran/verifikasi/' + id).then((response) => {
    return response.data;
  });
};

const changePaymentStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'verifikasi-pembayaran/status/' + id, data).then((response) => {
    return response.data;
  });
};

const VerifikasiPembayaranService = {
  getList,
  read,
  verifikasi,
  changePaymentStatus
};

export default VerifikasiPembayaranService;


